/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InKeyPublicPem: core.serialization.ObjectSchema<serializers.InKeyPublicPem.Raw, Truvity.InKeyPublicPem> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace InKeyPublicPem {
    export interface Raw {
        values: string[];
    }
}
